/**
 * For more info go there: https://github.com/alexsasharegan/vue-functional-data-merge#readme
 */
import { mergeData } from 'vue-functional-data-merge'
import '@/assets/scss/_grid/_container.scss'

const props = {
  tag: {
    type: String,
    default: 'div'
  },
  fluid: {
    type: Boolean,
    default: false
  }
}

export default {
  name: 'Conatiner',
  functional: true,
  props,
  render(h, { props, data, children }) {
    const componentData = {
      staticClass: 'bt-container',
      class: { 'bt-container--fluid': props.fluid }
    }

    return h(props.tag, mergeData(data, componentData), children)
  }
}
